<template>
  <div v-if="mode=='setup'" class="zone flex justify-content-center flex-vertical">
    <span class="h2">Z{{zone}}</span>
    <span class="h3 mb-1">{{user.zones[zone-1].intensity}}</span>  
    <span class="h3">{{user.zones[zone-1].lower}} - {{user.zones[zone-1].upper}} bpm </span> 
  </div>
  <div v-else class="zone flex justify-content-center flex-vertical">
    <span class="h2 mt-1">Z{{zone}}</span>
    <span class="h3">{{user.zones[zone-1].intensity}}</span>  
  </div>
</template>

<script>
  export default {
    name: 'hrZone',
    
    props: {
      zone: Number, user:Object, mode: String,
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .zone {
    color:black;
    text-align:center;
    height:12vw;
  }

  .h2 {
    margin-top:-0.5vw;
  }

  .h3 {
    margin-top:-1vw;
  }

  .mb-1 {
    margin-bottom:.3vw;
  }

  .mt-1 {
    margin-top:1vw;
  }
</style>
